import { Component } from '@angular/core';

@Component({
  selector: 'app-asset-vehicle-approval-landing',
  templateUrl: './asset-vehicle-approval-landing.component.html',
  styleUrls: ['./asset-vehicle-approval-landing.component.scss']
})
export class AssetVehicleApprovalLandingComponent {

}
